/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Denah_TInputs */

const en_tut_denah_t = /** @type {(inputs: Tut_Denah_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Areas, desks, and the floor plan`)
};

const id_tut_denah_t = /** @type {(inputs: Tut_Denah_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area, meja, dan denah kantor`)
};

/**
* | output |
* | --- |
* | "Areas, desks, and the floor plan" |
*
* @param {Tut_Denah_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_denah_t = /** @type {((inputs?: Tut_Denah_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Denah_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_denah_t(inputs)
	return en_tut_denah_t(inputs)
});